var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnFiberError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1180_4681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 0C28.6569 0 30 1.34315 30 3V27C30 28.6569 28.6569 30 27 30H21V25H9V30H3C1.34315 30 0 28.6569 0 27V3C3.86553e-07 1.34315 1.34315 0 3 0H27Z",
    fill: "#DB0046"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1180_4681"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H27C28.6569 0 30 1.34315 30 3V27C30 28.6569 28.6569 30 27 30H3C1.34315 30 0 28.6569 0 27V3Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFiberError);
export default __webpack_public_path__ + "static/media/icn_fiber_error.ad098768f8900e7194986930e10066cd.svg";
export { ForwardRef as ReactComponent };